import { memo } from 'react';
import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { UiButton } from 'src/components/UI/Button';
import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { useTHelper } from 'src/utils/i18n';

type Props = {
  model: CheckoutConfirmationResponseType['ButtonsSubsection'];
  savePreferences: () => void;
  savePreferencesLoading: boolean;
};

export const CheckoutConfirmationButtons = memo<Props>(({ model, savePreferencesLoading, savePreferences }) => {
  const tHelper = useTHelper('checkout.confirmation.buttons');

  return model.Buttons ? (
    <div className="row">
      <div className="col-lg-8 col-lg-offset-2">
        <div className="buttons-container">
          {model.Buttons.map((item) => (
            <UiInnerNotSPALink key={item.Url} className="btn btn-primary btn-lg BtnPrimary" href={item.Url}>
              {item.Title}
            </UiInnerNotSPALink>
          ))}

          {model.CanEdit && (
            <UiButton primary primaryNew className="btn-lg" onClick={savePreferences} disabled={savePreferencesLoading}>
              {tHelper('continue')}
            </UiButton>
          )}
        </div>
      </div>
    </div>
  ) : null;
});
